/**
 * Classification type enum for the overall classification result
 */
export enum ClassificationType {
  HARMFUL_CONTENT = 'harmful_content',
  SAFE_CONTENT = 'safe_content',
}
